import { render, staticRenderFns } from "./savingsperuser.vue?vue&type=template&id=401c01f9"
import script from "./savingsperuser.vue?vue&type=script&lang=js"
export * from "./savingsperuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports